import { StaticImage } from "gatsby-plugin-image"
import * as React from "react"
import { useEffect, useState } from "react"
export const ThemeSwitcher = () => {
  const [selectedTheme, setSelectedTheme] = useState<string | undefined>(
    undefined
  )

  useEffect(() => {
    if (typeof window !== "undefined") {
      let theme = localStorage.getItem("theme")
      if (!theme) {
        theme = "dark"
        localStorage.setItem("theme", theme)
      }
      setSelectedTheme(theme)
    }
  }, [])

  // theme change handler
  const themeHandler = (event: any) => {
    const selectedValue = event.target.value
    setSelectedTheme(selectedValue)
    if (typeof window !== "undefined") {
      localStorage.setItem("theme", selectedValue)
    }
  }
  return (
    <div className="flex gap-2 px-1 w-[95px] bg-input hover:opacity-70 transition duration-100 ease-in bg-glass items-center rounded-lg relative">
      <select
        value={selectedTheme}
        onChange={themeHandler}
        className={` pr-5 outline-none custom-select w-full z-20 cursor-pointer lg:py-3 py-2 flex gap-2 items-center bg-transparent font-semibold font-inter text-sm ${
          selectedTheme === "dark" && "text-black"
        } ${
          (selectedTheme === "" ||
            selectedTheme === null ||
            selectedTheme === undefined) &&
          "gradient-glassy-text"
        } ${selectedTheme === "light" && "gradient-light-text"} `}
        data-choose-theme
      >
        <option value="b" style={{ fontSize: "5pt" }} disabled>
          &nbsp;
        </option>
        <option value="glassy">Glassy</option>
        <option value="light">Light</option>
        <option value="dark">Dark</option>
        <option value="a" style={{ fontSize: "5pt" }} disabled>
          &nbsp;
        </option>
      </select>
      <div
        className={`w-4 absolute z-10 top-[30%] ${
          selectedTheme === "glassy" ||
          selectedTheme === null ||
          selectedTheme === undefined
            ? "xl:right-5 right-[20%]"
            : "xl:right-7 right-[25%]"
        }`}
      >
        {(selectedTheme === "glassy" ||
          selectedTheme === null ||
          selectedTheme === undefined) && (
          <StaticImage
            placeholder="blurred"
            className="w-full"
            src="./glass.png"
            alt="glass"
          />
        )}
        {selectedTheme === "dark" && (
          <StaticImage
            placeholder="blurred"
            className="w-4"
            src="./moon.png"
            alt="dark"
          />
        )}
        {selectedTheme === "light" && (
          <StaticImage
            placeholder="blurred"
            className="w-4"
            src="./sun.png"
            alt="sun"
          />
        )}
      </div>
    </div>
  )
}
